import {usePreviewContext} from "../../context/PreviewContext";
import {metaDataElementWithId, metaDataForPlacement} from "./previewMetaData";

interface Props {
    placementName?: string,
    children: any,
    hasItems?: boolean
}
function PreviewPlacementHighlighter(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    if (isPreview && props.placementName) {
        return <span {...metaDataForPlacement(isPreview, props.placementName, props.hasItems)}>{props.children}</span>
    } else {
        return <>{props.children}</>
    }
}
export default PreviewPlacementHighlighter;